import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Table, Modal, Tag } from 'antd';
import Pager from 'shared_components/search_pager';
import { GLOBAL_TABLE_PAGE_SIZE } from 'global_config/constant-global';

import './index.css';

const columns = [
	{
		title: 'REQUEST DATE',
		dataIndex: 'requestDateTime',
		width: 170, // custom aa
		fixed: 'left',
		render: text => text.replace(/\//g, '-'),
	},
	{
		title: 'REQUEST ID',
		dataIndex: 'requestID',
		width: 130,
		fixed: 'left',
	},
	{
		title: 'SAMPLE ID NO.',
		width: 110,
		render: record => record.contents.sampleSpecimenID,
	},
	{
		title: 'SPECIMEN',
		render: record => record.contents.specimenName,
		width: 100,
	},
	{
		title: 'LAST NAME',
		dataIndex: 'lastName',
		width: 150,
	},
	{
		title: 'FIRST NAME',
		dataIndex: 'givenName',
		width: 150,
	},
	{
		title: 'STATUS',
		width: 150,
		render: (text, record) => (
			<Tag
				style={{
					cursor: 'pointer', // Add cursor pointer for better UX
				}}
				// @ts-ignore
				onClick={() => this.handleOnClickStatus(record.specimenRemarks)}
				color={getStatusColor(record.contents.specimenStatusID)}
			>
				{record.contents.specimenStatus.toUpperCase()}
			</Tag>
		),
	},
	{
		title: 'BIRTHDATE',
		dataIndex: 'dateOfBirth',
		width: 100,
	},
	{
		title: 'GENDER',
		dataIndex: 'sex',
		width: 80,
	},
	// {
	// 	title: 'HOSPITAL ID',
	// 	dataIndex: 'hospitalID',
	// 	width: 100,
	// },
	{
		title: 'PATIENT ID',
		dataIndex: 'patientID',
		width: 100,
	},
	{
		title: 'ADDRESS',
		width: 400,
		render: (text, record) =>
			`${record.address || ''} ${record.townName || ''} ${record.cityMunicipalityName ||
				''} ${record.provinceName || ''}`.toUpperCase(),
	},
	// {
	// 	title: 'SECTION',
	// 	width: 100,
	// 	render: record => record.contents.sectionName,
	// },
	{
		title: 'EXAM REQUESTED',
		fixed: 'right',
		width: 160,
		render: record => record.contents.examRequestNames,
	},
];

function getStatusColor(status) {
	if (status === 0) {
		return '#C65911';
	} else if (status === 1) {
		return '#833C0C';
	} else if (status === 2) {
		return '#BF8F00';
	} else if (status === 3) {
		return '#00B050';
	} else if (status === 4) {
		return '#FC1C04';
	} else if (status === 5) {
		return '#305496';
	} else if (status === 6) {
		return '#002060';
	} else if (status === 7) {
		return '#CC66FF';
	} else if (status === 8) {
		return '#00B050';
	} else if (status === 9) {
		return '#FC1C04';
	} else {
		return '#8A73F9'; // default color if status doesn't match any range
	}
}

class SectionTable extends React.Component {
	state = {
		pageSize: GLOBAL_TABLE_PAGE_SIZE,
		remarks: '',
		modalReject: false,
	};

	handleOnClickStatus = remarks => {
		if (remarks != null) {
			if (remarks.length > 0) {
				this.setState({ remarks: remarks, modalReject: true });
			}
		}
	};

	onChangePageSize = pageSize => {
		this.setState({ pageSize });
	};

	render() {
		const { pageSize, modalReject, handleOkCancelReject, remarks } = this.state;
		const { labResults, onClickTableRow } = this.props;

		console.log(labResults);

		return (
			<div>
				<Row>
					<Col lg={24} xs={24}>
						<Pager
							handleChangeSize={this.onChangePageSize}
							pageTotal={labResults.length}
							pageSize={pageSize}
						/>
					</Col>
				</Row>
				<div className="space-y-sm"></div>
				<div className="lab-result-section-table-contianer">
					<Table
						className="lab-result-section-table"
						columns={columns}
						pagination={{ pageSize, showSizeChanger: false }}
						dataSource={labResults}
						rowKey={record => record.contents.sampleSpecimenID}
						onRow={record => {
							const { contents, ...restProps } = record;

							const isDisabled = !(
								record.contents.specimenStatusID === 1 ||
								record.contents.specimenStatusID === 2 ||
								record.contents.specimenStatusID === 3 ||
								record.contents.specimenStatusID === 4 ||
								record.contents.specimenStatusID === 8
							);

							console.log(isDisabled);
							console.log(record.contents.specimenStatusID);

							return {
								onDoubleClick: () => {
									if (!isDisabled) {
										onClickTableRow({
											patientInfo: { ...restProps },
											examDetails: contents,
										});
									}
								},
								// style: {
								// 	cursor: isDisabled ? 'not-allowed' : 'pointer',
								// },
							};
						}}
						scroll={{ x: 1500 }}
						// scroll={{ y: 'calc(100vh - 600px)' }}
					/>
				</div>
				<Modal
					title="Reject Reason"
					visible={modalReject}
					onOk={handleOkCancelReject}
					onCancel={handleOkCancelReject}
				>
					<p>{remarks}</p>
				</Modal>
			</div>
		);
	}
}

SectionTable.propTypes = {
	labResults: PropTypes.array.isRequired,
	onClickTableRow: PropTypes.func.isRequired,
};

export default SectionTable;
